import { auth, database } from "firebase";
import Push from "push.js";

export const add = ({ id, name }) => {
    const { uid } = auth().currentUser
    database().ref(`users/${uid}`).once('value').then(e => {
        const baseItem = { id, name, interval: 1000 * 60 }
        if (e.val()) {
            const ObjectIds = Object.keys(e.val())
            const ids = ObjectIds.map(i => e.val()[i].id)
            const isDupe = ids.indexOf(id) > -1;
            if (isDupe) {
                Push.create("You have already added this to your list.")
            } else {
                database().ref(`users/${uid}`).push(baseItem);
            }
        } else {
            database().ref(`users/${uid}`).push(baseItem);
        }
    })
}

export const min = ({ id }) => {
    const { uid } = auth().currentUser
    database().ref(`users/${uid}`).once('value').then(e => {
        if (e.val()) {
            const ObjectIds = Object.keys(e.val())
            const item = ObjectIds.filter(i => e.val()[i].id === id)
            database().ref(`users/${uid}/${item}`).remove()
        }
    })
}

export const toggleNotification = ({ id,name,interval }) => {
    const { uid } = auth().currentUser
    return database().ref(`users/${uid}`).once('value').then(e => {
        if (e.val()) {
            const newInterval = interval > 0 ? 0 : 1000 * 60 
            const ObjectIds = Object.keys(e.val())
            const item = ObjectIds.filter(i => e.val()[i].id === id)
            database().ref(`/users/${uid}/${item}`).update({interval:newInterval});
        }
    })
}

// export const update = (props,{id}) => {
//     const { uid } = auth().currentUser
//     const newData = {}
//     // newData[`/users/${uid}/${id}`] = {

//     // }
//     // database().ref().update(newData)
// }


// WEBPACK FOOTER //
// ./src/ui/item/functions/CRUD.js